import React from 'react';
import Modal from 'components/UI/Modal';
import CloseButton from 'components/UI/CloseButton';
import Title from 'components/UI/Title';
import { observer, modal as modalStore } from 'store';
import { useTrans } from 'utils/localisation';

import * as styles from './LangNotificationModal.module.scss';

function LangNotificationModal({ animation = 'show', modalID = 'LangNotificationModal' }) {
  const t = useTrans(['common', 'langNotificationModal']);
  const isOpen = modalStore.modalID === modalID;
  const { href, target, title, subtitle } = modalStore.modalProps;

  return (
    <Modal
      isOpen={isOpen}
      closeModalCallback={modalStore.close}
      containerMod="langNotificationModal"
      contentMod="paddingXXL"
      closeButton={false}
      animation={animation}
    >
      {onClose => (
        <div className={styles.content}>
          <Title tag="h4" className={styles.title}>
            {title ?? t('langNotificationTitle')}
          </Title>
          <p className={styles.subtitle}>{subtitle ?? t('langNotificationSubtitle')}</p>
          <a href={href} target={target} className={styles.link} onClick={onClose}>
            {t('continue')}
          </a>
          <CloseButton onClose={onClose} theme="dark" />
        </div>
      )}
    </Modal>
  );
}

export default observer(LangNotificationModal);
